<template>
  <div class="single-file-alert alert">
    <div class="single-file-box alert_box">
      <h3>
        등록 중인 스페이스가 저장되었습니다.<br />
        언제든 마이스페이스에서 이어서 등록이 가능합니다. 😊
      </h3>
      <div class="single-file-check">
        <p style="margin-bottom: 0px;" @click="linkMySpace()">확인</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cancelModal',
  methods: {
    linkMySpace() {
      this.$router.push({ name: 'buildingBridge' }).catch(() => {});
    }
  }
};
</script>

<style scoped>
@media all and (max-width: 500px) {
  .single-file-check p {
    font-size: 15px !important;
    color: #ff2d55;
    font-weight: 400;
  }
}
</style>
